import { createNextTableContext } from '@core/table';

export const BoxesTableContext = createNextTableContext();
